export default {
    data() {
        return {
            phone_rules: [
                function (v) {
                    return !!v || "Please provide a phone number";
                },
                function (v) {
                    return (v && v.length > 8) || "Please enter a valid phone number";
                }
            ],
            phone_rules_v2: [
                function (v) {
                    return !!v || "Please provide a mobile number";
                },
                function (v) {
                    return (v && v.length > 8) || "Please enter a valid mobile number";
                }
            ],
            name_rules: [
                function (v) {
                    return !!v || "Field is required";
                }
            ],
            name_rules_v2: [
                function (v) {
                    return !!v || "Please enter a valid name";
                }
            ],
            email_rules: [
                function (v) {
                    return !!v || "Please provide an email address";
                },
                function (value) {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                    return pattern.test(value) || "Please enter a valid email address.";
                }
            ],
            dob_rules: [
                function (v) {
                    return !!v || "Please provide a valid date";
                },
            ]
        }
    },
    methods: {
        lookupAddress: function lookupAddress(ev) {
            if (ev && ev.length > 2) {
                this.requestAddress(ev, 1)
            }
        },
        lookupAddress2: function lookupAddress(ev) {
            if (ev && ev.length > 2) {
                this.requestAddress(ev, 2)
            }
        },
        requestAddress: function requestAddress(ev, index) {
            var that = this;
            var api_url = process.env.ADDRESSRIGHT_API_URL + process.env.ADDRESSRIGHT_API_KEY + '&term=' + ev;
            fetch(api_url, {
                method: "GET",
                headers: { "Content-type": "application/json; charset=UTF-8" }
            }).then(function (response) {
                if (response.ok) {
                    return response.json();
                }
                return Promise.reject(response);
            }).then(function (data) {

                if (index === 1) {
                    if (data[0].results.length) {
                        that.address_suggestions_1 = data[0].results;
                    } else {
                        that.address_suggestions_1 = [];
                        that.cleanAddress_details(1)
                    }
                } else {
                    if (data[0].results.length) {
                        that.address_suggestions_2 = data[0].results;
                    } else {
                        that.address_suggestions_2 = [];
                        that.cleanAddress_details(2)
                    }
                }
            }).catch(function (error) {
                console.warn("Something went wrong.", error);
            });
        },
        makeDetailedAddressCall: function makeDetailedAddressCall(addressId, index) {
            var that = this;
            var api_url = process.env.ADDRESSCALL + process.env.ADDRESSRIGHT_AUTH_DEV + '&id=' + addressId;

            fetch(api_url, {
                method: "GET",
                headers: { "Content-type": "application/json; charset=UTF-8" }
            }).then(function (response) {
                if (response.ok) {
                    return response.json();
                }
                return Promise.reject(response);
            }).then(function (data) {
                that.fillAddress_details(data, index)
                that.updateData();
            }).catch(function (error) {
                console.warn("Something went wrong.", error);
            });
        },
        cleanLookupSuggestions: function cleanLookupSuggestions() {
            if (!this.is_touch_device()) this.address_suggestions_1 = []
        },
        cleanLookupSuggestions2: function cleanLookupSuggestions2() {
            if (!this.is_touch_device()) this.address_suggestions_2 = []
        },
        is_touch_device: function is_touch_device() {
            return !!('ontouchstart' in window        // works on most browsers 
            || navigator.maxTouchPoints);       // works on IE10/11 and Surface
        },
        getRadioLabel: function getRadioLabel(n) {
            return n === 1 ? "Yes" : "No";
        },
        getRadioValue: function getRadioValue(n) {
            return n === 1 ? true : false;
        },
        validateEmail: function validateEmail(email) {
            const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        validatePhone: function validatePhone(phone) {
            return phone && phone.length > 8 && phone.length < 31
        },
        debouncedDataUpdate: function debouncedDataUpdate(){
            if (typeof window.LIT !== "undefined") {
                clearTimeout(window.LIT);
            }
            window.LIT = setTimeout(() => {
                this.updateData();
            }, 500);
        },
        immediateDataUpdate: function immediateDataUpdate(){
            this.updateData();
        },
        debouncedSendDataToAPI: function debouncedSendDataToAPI(){
            if (typeof window.SDTA !== "undefined") {
                clearTimeout(window.SDTA);
            }
            window.SDTA = setTimeout(() => {
                this.sendDataToAPI();
            }, 500);
        }
    }
};